export default __webpack_public_path__ + "static/media/circle.444c79a6.png";